"use client";

import React from "react";
import { X } from "lucide-react";
import MailingListSignupForm from "@/app/components/ui/MailingListSignupForm";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export default function MailingListModal({ isOpen, onClose }: Props) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl max-w-lg w-full p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>

        <h2 className="text-2xl font-bold text-widertalk-navy mb-2">Join our mailing list</h2>
        <p className="text-gray-600 mb-6">
          Get the latest updates on new features, events, and highlights. No spam, unsubscribe anytime.
        </p>

        <MailingListSignupForm
          buttonLabel="Join Mailing List"
          onSuccess={() => {
            try { localStorage.setItem('wt_ml_prompted', '1'); } catch {}
            onClose();
          }}
        />
      </div>
    </div>
  );
}
